import React from 'react';

import ApplicationTrackerImage from '../../assets/application_tracker.png';

const JobApplicationsTracker = () => {
  return (
    <section id="job-applications-tracker" className="w-full font-sans px-4 md:px-8 bg-white">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center">
        {/* Mobile: Image first, Desktop: Image second */}
        <div className="w-full md:w-1/2 bg-[#EFE8FF] rounded-3xl p-8 flex flex-col items-center justify-center order-1 md:order-2">
          <img src={ApplicationTrackerImage} alt="Screenshot of the Job Applications Tracker feature showing organized job entries" className='w-full h-full object-cover' />
        </div>
        
        {/* Mobile: Content second, Desktop: Content first */}
        <div className="w-full md:w-1/2 pr-0 md:pr-12 mb-12 md:mb-0 order-2 md:order-1">
          <p className="text-sm text-gray-600 mb-2 mt-4">Job Applications Tracker</p>
          <h2 className="text-[24px] md:text-4xl md:font-sans mb-4 md:mb-12">Save Jobs. Stay Organised. Manage Your job Search.</h2>
          <p className='text-[16px] md:text-base mb-6 md:mb-12'>A faster, smarter way to stay on top of your job hunt. Easily track, bookmark, and organise opportunities from our job board, all in one place. Say goodbye to scattered tabs and missed deadlines.</p>
          <button className='bg-black text-white py-2 px-4 rounded-3xl'
          onClick={() => {
            window.location.href = '/signup';
          }}
          >Start Organising Now</button>
        </div>
      </div>
    </section>
  );
};

export default JobApplicationsTracker;